import {
  isSameMonth,
  isSameWeek,
  isThisMonth,
  isThisWeek,
  isToday,
  isYesterday,
  subDays,
  subMonths,
  subWeeks,
} from 'date-fns'

export function checkToday(date: Date): boolean {
  return isToday(date)
}

export function checkYesterday(date: Date): boolean {
  return isYesterday(date)
}

export function checkNDaysAgo(date: Date, n: number): boolean {
  const comparisonDate = subDays(new Date(), n)

  return date.toDateString() === comparisonDate.toDateString()
}

export function checkLastWeek(date: Date): boolean {
  const today = new Date()

  const lastWeek = subWeeks(today, 1)

  return isSameWeek(date, lastWeek) && !isThisWeek(date)
}

export function checkNWeeksAgo(date: Date, n: number): boolean {
  const today = new Date()

  const weeksAgo = subWeeks(today, n)

  return isSameWeek(date, weeksAgo)
}

export function checkLastMonth(date: Date): boolean {
  const today = new Date()

  const lastMonth = subMonths(today, 1)

  return isSameMonth(date, lastMonth) && !isThisMonth(date)
}
